import { TeamViewModel } from "../models/Team";
import api from "./api";

export const getTeams = async (): Promise<TeamViewModel[] | undefined> => {
  try {
    const response = await api.get(`/api/team`);
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const getTeamById = async (id: string) => {
  try {
    const response = await api.get(`/api/team/${id}`);
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

export const saveTeam = async (team: TeamViewModel) => {
  try {
    const response = await api.post(`/api/team`, team);
    return response;
  } catch (error) {
    console.log("error", error);
  }
};

export const updateTeam = async (team: TeamViewModel) => {
  try {
    const response = await api.put(`/api/team/${team.id}`, team);
    return response;
  } catch (error) {
    console.log("error", error);
  }
};

export const deleteTeam = async (id: string) => {
  const response = await api.delete(`/api/team/${id}`);
  return response;
};
